<template>
  <div>
    <!-- Image Fullscreen Preview -->
    <v-dialog v-model="filterDialog" maxWidth="350" persistent>
      <v-card max-width="350" class="rounded-lg py-5" color="greyColorLigthTwo">
        <v-card-text>
          <v-combobox
            v-if="showIsAssigned"
            v-model="isAssignedModel"
            :items="isAssignedItems"
            color="defaultColor"
            class="mt-5"
            hide-details
            item-text="text"
            outlined
            rounded
            item-value="value"
            :label="$t('labels.selectStatus')"
            persistent-hint
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('description.noContent') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>

          <v-combobox
            v-if="showSort"
            v-model="sortModel"
            :items="sortItems"
            color="defaultColor"
            class="mt-5"
            hide-details
            item-text="text"
            outlined
            rounded
            item-value="value"
            :label="$t('labels.selectSort')"
            persistent-hint
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('description.noContent') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>

          <v-combobox
            v-if="showDate"
            v-model="createdModel"
            :items="createdItems"
            color="defaultColor"
            class="mt-4"
            hide-details
            item-text="text"
            outlined
            rounded
            item-value="value"
            :label="$t('labels.selectCreatedAt')"
            persistent-hint
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('description.noContent') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>

          <v-combobox
            v-if="showCategory"
            v-model="categoryModel"
            :items="categoryItems"
            color="defaultColor"
            class="mt-4"
            hide-details
            item-text="CategoryNameTR"
            outlined
            rounded
            item-value="Id"
            :label="$t('labels.selectCategory')"
            persistent-hint
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('description.noContent') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </v-card-text>
        <v-card-actions class="py-0 my-0">
          <v-btn
            v-if="showClearAll"
            @click="clearFilter"
            color="defaultColor"
            text
            small
            class="mr-2 text-capitalize"
          >
            Tüm Seçimleri Temizle
          </v-btn>
        </v-card-actions>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="defaultColor"
            class="white--text text-capitalize"
            text
            rounded
            :disabled="filterLoading"
            @click="closeDialog()"
          >
            {{ $t('buttons.cancelUpper') }}
          </v-btn>
          <v-btn
            color="defaultColor"
            class="white--text text-capitalize mr-3"
            outlined
            rounded
            :loading="filterLoading"
            @click="filterData()"
          >
            {{ $t('buttons.filter') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn icon color="defaultColor" @click="filterDialog = true">
      <v-icon>mdi-tune</v-icon>
    </v-btn>
  </div>
</template>

<script>
import CategoryService from '../../services/CategoryService';
export default {
  data: function () {
    {
      return {
        filterDialog: false,
        filterLoading: false,

        isAssignedModel: '',
        isAssignedItems: [
          { text: this.$t('menu.showAll'), value: '0' },
          { text: this.$t('menu.isAssginedToMe'), value: '1' },
          { text: this.$t('menu.completedTrainings'), value: '2' },
        ],

        sortModel: '',
        sortItems: [
          { text: this.$t('menu.sortAZ'), value: '1' },
          { text: this.$t('menu.sortZA'), value: '2' },
          { text: this.$t('menu.sortOldToNew'), value: '3' },
          { text: this.$t('menu.sortNewToOld'), value: '4' },
        ],

        createdModel: '',
        createdItems: [
          { text: this.$t('menu.dataLastOne'), value: this.getLastDate(1) },
          { text: this.$t('menu.dataLastTwo'), value: this.getLastDate(3) },
          { text: this.$t('menu.dataLastThree'), value: this.getLastDate(6) },
        ],

        categoryModel: '',
        categoryItems: [],
      };
    }
  },
  props: {
    showIsAssigned: {
      type: Boolean,
      default: false,
    },
    showSort: {
      type: Boolean,
      default: true,
    },
    showDate: {
      type: Boolean,
      default: true,
    },
    showCategory: {
      type: Boolean,
      default: true,
    },
    showClearAll: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  mounted() {
    if (!this.showIsAssigned) {
      this.getCategories();
    }
  },

  methods: {
    getCategories() {
      //TODO: Burada servis ID ile çalışmamalı, key benzeri parametre ile çalışmalı
      let id = '62a1aa366e569d6087ec1b68';
      this.categoryLoading = true;
      CategoryService.getCategories(id)
        .then((res) => {
          if (res.data) {
            this.categoryItems = res.data.Children;
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          this.categoryLoading = false;
        });
    },

    getLastDate(mounth) {
      return this.moment(new Date()).subtract(mounth, 'M').format('DD.MM.YYYY');
    },

    closeDialog() {
      this.filterDialog = false;
    },

    clearFilter() {
      this.isAssignedModel = '';
      this.sortModel = '';
      this.createdModel = '';
      this.categoryModel = '';
    },

    filterData() {
      let isAssigned = this.isAssignedModel ? this.isAssignedModel : '';
      let sort = this.sortModel ? this.sortModel.value : '';
      let createdModel = this.createdModel ? this.createdModel.value : '';
      let categoryModel = this.categoryModel ? this.categoryModel.Id : '';
      let categoryName = this.categoryModel
        ? this.categoryModel.CategoryNameTR
        : '';
      this.$emit('filterData', {
        isAssigned: isAssigned,
        sort: sort,
        created: createdModel,
        category: categoryModel,
        categoryName: categoryName,
      });
      this.closeDialog();
    },
  },
  computed: {},
};
</script>
